import { render, staticRenderFns } from "./DiscountsList.vue?vue&type=template&id=1ff5792e&scoped=true&"
import script from "./DiscountsList.vue?vue&type=script&lang=js&"
export * from "./DiscountsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff5792e",
  null
  
)

export default component.exports